import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = ["aria-label"]

import { Dropdown } from 'bootstrap';
import { computed, onMounted, ref, watch } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'DropDown',
  props: {
    itemCount: {},
    label: {},
    isPrimaryButton: { type: Boolean }
  },
  setup(__props: any, { expose: __expose }) {


const props = __props;

let dropdownElement = ref(null);
let dropdownObject = {} as Dropdown;

const state = ref(false);

onMounted(() => {
    if(dropdownElement?.value != undefined){
        dropdownObject = new Dropdown(dropdownElement.value);        
    }    
});

const buttonCss= computed(()=> {
    let css= "btn border border-secondary dropdown-toggle";
    if(props.isPrimaryButton){
        css = "btn btn-primary dropdown-toggle";
    }

    return css;
})

function _show() {
    state.value = true;
    if(dropdownObject){
        dropdownObject.show();
    }
}

function _hide() {
    state.value = false;

    if(dropdownObject){
        dropdownObject.hide();
    }
}

__expose({ show: _show, hide: _hide });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "dropdown",
    ref_key: "dropdownElement",
    ref: dropdownElement
  }, [
    _createElementVNode("button", {
      type: "button",
      class: _normalizeClass(buttonCss.value),
      "data-bs-toggle": "dropdown",
      "aria-expanded": "false"
    }, _toDisplayString(__props.label), 3),
    _createElementVNode("ul", {
      class: "dropdown-menu",
      "aria-label": __props.label
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.itemCount, (index) => {
        return (_openBlock(), _createElementBlock("li", null, [
          _renderSlot(_ctx.$slots, `item${index}`, { item: index })
        ]))
      }), 256))
    ], 8, _hoisted_1)
  ], 512))
}
}

})